import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top of the page on route change
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // 'instant' is preferred for page transitions to avoid jarring movement
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;